export const externalUrls = {
  oceanCredit: {
    home: 'https://oceancredit.ro',
    contact: 'https://oceancredit.ro/contact',
    blog: 'https://oceancredit.ro/blog',
    rejectionReasons:
      'https://www.oceancredit.ro/blog/de-ce-nu-se-aproba-unele-solicitari-pentru-credite-online-4-motive-principale',
    creditLineDetails:
      'https://www.oceancredit.ro/linie-credit-nevoi-personale-fara-garantii',
  },

  volt: {
    home: 'https://www.volt.ro',
    appDownload: 'https://link.volt.ro/app',
    terms: 'https://www.volt.ro/terms/termenii-de-utilizare-credit',
    privacy: 'https://www.volt.ro/terms/politica-de-confidentialitate-credit',
    contact: 'https://www.volt.ro/contact',
    blog: 'https://www.volt.ro/blog',
    cookiePolicy: 'https://www.volt.ro/politica-de-cookies',
  },
} as const;
